/* eslint-disable @typescript-eslint/no-empty-interface */

// module imports required for module augmentation
import '@mui/material/Button';
import '@mui/material/Typography';

import { Theme } from '@mui/material/styles';
import type {
  ComponentOverridesAugmentation,
  ThemeAugmentation,
} from '@bymason-private/controller-v1-theme-augmentation';

// this is required because makeStyles (in v5) has no knowledge
// of the Theme object; see https://next.material-ui.com/guides/migration-v4/
declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

declare module '@mui/material/styles' {
  interface ComponentsOverrides extends ComponentOverridesAugmentation {}
  interface Theme extends ThemeAugmentation {}
  interface ThemeOptions extends ThemeAugmentation {}
}

export { Theme } from '@mui/material/styles';
export * from '@mui/styles';
export { useMediaQuery } from '@mui/material';

export * from './controller';
export * from './utils';
